<script setup lang="ts">
import { computed } from 'vue'

import type { AdditionalHeaders } from '../paragraph-types/ParagraphTypeEpgDetailHeader.vue'

type MetadataHeaderInfo = NonNullable<NonNullable<AdditionalHeaders['metadata']>['top']> & NonNullable<NonNullable<AdditionalHeaders['metadata']>['bottom']>

const props = defineProps<{
  metaInfos: MetadataHeaderInfo
}>()

// defined order of metaInfos
const keyOrder: (keyof MetadataHeaderInfo)[] = ['airDate', 'airTime', 'country', 'year', 'genre', 'runtime', 'channelName']

const orderedKeys = computed(() => {
  // fallback index for keys not already in keyOrder
  const fallbackIndex = keyOrder.length
  // order the keys according to the defined order
  return (Object.keys(props.metaInfos) as (keyof MetadataHeaderInfo)[])
    .sort((a, b) => {
      const indexA = keyOrder.indexOf(a)
      const indexB = keyOrder.indexOf(b)
      return (indexA === -1 ? fallbackIndex : indexA) - (indexB === -1 ? fallbackIndex : indexB)
    })
    // https://bauerxcel.atlassian.net/browse/NXT-9038
    // key `channel` not yet ready
    // will be done in subtask https://bauerxcel.atlassian.net/browse/NXT-9054
    .filter((key) => key !== 'channel')
})

const formattedValue = (key: keyof MetadataHeaderInfo, value: MetadataHeaderInfo[keyof MetadataHeaderInfo]) =>
  key === 'runtime' ? `${value} min.` : value
</script>

<template>
  <ul class="bx-content bx-content__meta bx-typo--content-meta">
    <li v-for="(key, index) in orderedKeys"
        :key="index">
      {{ formattedValue(key, metaInfos[key]) }}
    </li>
  </ul>
</template>
